import React from "react";
import SunEditor, {buttonList} from 'suneditor-react';
import plugins from 'suneditor/src/plugins'
import OsMediaLibrary from './media-library/plugin';

import "./htmlInput.css";
import 'suneditor/dist/css/suneditor.min.css';
import {imagePlugin} from "./imagePlugin/imagePlugin";


const HtmlInput = ({ 
                    label, 
                    content, 
                    inputName, 
                    onChangeContent, 
                    withWrapper = true,
                    wrapperClassName = 'form-group' 
                  }) => {

  const onChange = (content) => {
    if ( typeof(onChangeContent) === 'function' )
      onChangeContent( inputName, content );
  };

  let plugin_list = {};
  Object.assign(
    plugin_list,
    plugins,
    {
      'osMediaLibrary' : OsMediaLibrary,
        image:imagePlugin,
    }
  );

  let button_list_for_editor = [];
  Object.assign( button_list_for_editor, buttonList.complex )
  button_list_for_editor.push([{
                                'name' : 'osMediaLibrary',
                                'dataDisplay' : 'dialog',
                                'buttonClass' : 'os-media-library-editor-button',
                                'title' : 'Медіа файли',
                                'innerHTML' : '<span><span class="fa fa-folder-open"></span> <span>Медіа файли</span></span>',
                              }]);

  let html = null;
  if ( withWrapper ) {
    html = (
          <div className={wrapperClassName}>
            <label>{label}</label>
            <SunEditor
              lang="ua"
              setContents={content}
              onChange={onChange}
              setAllPlugins={true}
              setOptions={{
                'plugins' : plugin_list,
                'buttonList' : button_list_for_editor,
                'imageSizeOnlyPercentage' : true,
                // 'videoSizeOnlyPercentage' : true,
                'defaultStyle': "font-size:14px;"
              }}
            />
        </div>
      );
  } else {
    html = (
          <>
            <label>{label}</label>
            <SunEditor
              lang="ua"
              setContents={content}
              onChange={onChange}
              setAllPlugins={true}
              setOptions={{
                'plugins' : plugin_list,
                'buttonList' : button_list_for_editor,
                'imageSizeOnlyPercentage' : true,
                // 'videoSizeOnlyPercentage' : true,
                'defaultStyle': "font-size:14px;"
              }}
            />
        </>
      );
  }

  return html;
};

export default HtmlInput;
